<template>
    <v-container fluid>
        <v-layout align-start>
            <v-flex>
                <!-- Modern Page Header -->
                <div class="page-header mb-6">
                    <div class="d-flex align-center">
                        <v-icon large color="primary" class="mr-3">gps_fixed</v-icon>
                        <div>
                            <h1 class="text-h4 font-weight-bold grey--text text--darken-3 mb-0">Gestión de Localidades
                            </h1>
                            <span class="text-subtitle-1 grey--text">Administra y configura los puntos operativos del
                                sistema</span>
                        </div>
                    </div>
                </div>

                <v-card class="modern-card" elevation="2">
                    <v-data-table :headers="headers" :items="locations" :search="search" class="modern-table"
                        fixed-header height="60vh">
                        <template v-slot:top>
                            <v-toolbar flat color="transparent" class="px-2">
                                <v-badge color="primary" :content="locations.length" overlap class="mr-4">
                                    <span class="text-h6 font-weight-medium">Localidades</span>
                                </v-badge>

                                <v-spacer></v-spacer>

                                <v-text-field v-model="search" prepend-inner-icon="search" label="Buscar localidad..."
                                    outlined dense hide-details class="search-field mr-4" rounded></v-text-field>

                                <v-btn color="primary" depressed rounded class="px-6 font-weight-bold"
                                    @click="openDialogLocation()">
                                    <v-icon left>add</v-icon>
                                    Nueva Localidad
                                </v-btn>
                            </v-toolbar>
                        </template>

                        <template v-slot:[`item.id`]="{ item }">
                            <v-chip small label color="primary" outlined class="font-weight-bold px-3">
                                {{ item.id }}
                            </v-chip>
                        </template>

                        <template v-slot:[`item.bus_status_id`]="{ item }">
                            <v-chip dark x-small label class="font-weight-bold"
                                :color="item.bus_status_id == '1' ? 'success' : 'grey'">
                                {{ item.bus_status_id == '1' ? 'UN ACTIVA' : 'UN INACTIVA' }}
                            </v-chip>
                        </template>

                        <template v-slot:[`item.sta_description`]="{ item }">
                            <v-chip dark x-small label class="font-weight-bold"
                                :color="item.status_id == '1' ? 'success' : 'error'">
                                {{ item.sta_description }}
                            </v-chip>
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                            <div class="d-flex align-center">
                                <v-btn icon color="primary" @click="editItem(item)" title="Editar">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on"
                                            @click="item.status_id == '1' ? deleteItem(item) : activeLocation(item)">
                                            <v-icon :color="item.status_id == '1' ? 'success' : 'error'">
                                                {{ item.status_id == '1' ? 'toggle_on' : 'toggle_off' }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ item.status_id == '1' ? 'Desactivar' : 'Activar' }}</span>
                                </v-tooltip>
                            </div>
                        </template>

                        <template v-slot:no-data>
                            <v-row justify="center" class="pt-10">
                                <v-icon size="80" color="grey lighten-2">location_off</v-icon>
                            </v-row>
                            <v-row justify="center" class="pb-10 grey--text">No se encontraron localidades</v-row>
                        </template>
                    </v-data-table>
                </v-card>

                <!-- Main Form Dialog -->
                <v-dialog v-model="dialog" max-width="800px" transition="dialog-bottom-transition" persistent>
                    <v-card class="modern-card overflow-hidden">
                        <v-toolbar flat color="primary" dark>
                            <v-icon class="mr-2">{{ editedIndex === -1 ? 'add_location' : 'edit_location' }}</v-icon>
                            <v-toolbar-title class="font-weight-bold">{{ formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="close"><v-icon>close</v-icon></v-btn>
                        </v-toolbar>

                        <v-card-text class="pa-6">
                            <v-container fluid class="pa-0">
                                <div class="text-overline grey--text mb-4">Información de Localidad</div>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-text-field v-model="newLocation.desc_loc_long" label="Nombre Completo"
                                            outlined rounded dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field v-model="newLocation.desc_loc_short" label="Nombre Corto / Alias"
                                            outlined rounded dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-autocomplete :items="allBusiness" v-model="newLocation.bus_id"
                                            item-text="description_long" item-value="id" label="Unidad de Negocio"
                                            prepend-inner-icon="business" outlined rounded dense></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field v-model="representante" label="Representante"
                                            append-icon="person_search" readonly @click:append="dialogSearch = true"
                                            @click="dialogSearch = true" outlined rounded dense
                                            placeholder="Seleccione un empleado"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field v-model="newLocation.rnl" label="RNL" outlined rounded
                                            dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-autocomplete :items="itemsCities" v-model="newLocation.city_id"
                                            label="Ciudad" prepend-inner-icon="pin_drop" outlined rounded
                                            dense></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field v-model="newLocation.location_adress" label="Dirección" outlined
                                            rounded dense></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions class="pa-6 pt-0">
                            <v-spacer></v-spacer>
                            <v-btn text color="grey darken-1" @click="close" rounded class="px-6">Cancelar</v-btn>
                            <v-btn color="primary" @click="save" :loading="loading" rounded depressed
                                class="px-8 font-weight-bold">
                                <v-icon left>save</v-icon> Guardar Localidad
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- Employee Search Dialog -->
                <v-dialog v-model="dialogSearch" max-width="450px" transition="dialog-fade-transition">
                    <v-card class="modern-card pa-4">
                        <div class="text-h6 font-weight-bold mb-4 primary--text d-flex align-center">
                            <v-icon color="primary" class="mr-2">person_search</v-icon>
                            Buscar Representante
                        </div>
                        <v-text-field v-model="employee_code_add" label="Código del Empleado" outlined rounded dense
                            autofocus @keyup.enter="searchEmployee" color="primary"></v-text-field>
                        <v-card-actions class="pa-0 mt-4">
                            <v-spacer></v-spacer>
                            <v-btn text color="grey darken-1" @click="dialogSearch = false" rounded>Cancelar</v-btn>
                            <v-btn color="primary" depressed rounded @click="searchEmployee" :loading="loadingSearch"
                                class="px-6">Buscar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- Deactivate Confirmation -->
                <v-dialog v-model="dialogDelete" max-width="450px" transition="dialog-center-transition">
                    <v-card class="modern-card pa-4 text-center">
                        <v-icon size="64" color="warning" class="mb-4">lock_open</v-icon>
                        <div class="text-h6 font-weight-bold mb-2">¿Desactivar Localidad?</div>
                        <div class="grey--text mb-6">Esta localidad ya no estará disponible para nuevas transacciones
                            operativas.</div>
                        <v-row justify="center">
                            <v-btn color="grey lighten-4" depressed rounded class="mx-2 px-6 grey--text text--darken-2"
                                @click="closeDelete">Cancelar</v-btn>
                            <v-btn color="warning" depressed rounded class="mx-2 px-6" dark
                                @click="deleteItemConfirm">Sí,
                                Desactivar</v-btn>
                        </v-row>
                    </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
export default {
    data: () => ({
        dialog: false,
        loadingSearch: false,
        loading: false,
        dialogDelete: false,
        dialogSearch: false,
        employee_code_add: '',
        representante: '',
        headers: [
            {
                text: "Codigo",
                align: "start",
                value: "id",
            },
            { text: "Location", value: "desc_loc_long" },
            { text: "Unidad de Negocio", value: "desc_bus_long" },
            { text: "Estado UN", value: "bus_status_id" },
            { text: "Nombre Corto", value: "desc_loc_short" },
            { text: "Ubicacion", value: "location_adress" },
            { text: "Estado", value: "sta_description" },
            { text: "Actions", value: "actions", sortable: false },
        ],
        search: null,
        locations: [],
        allBusiness: [],
        itemsCities: [],
        newLocation: {
            id: null,
            bus_id: 1,
            city_id: null,
            desc_bus_short: null,
            location_adress: null,
            desc_bus_long: null,
            desc_loc_short: null,
            desc_loc_long: null,
            status_id: null,
            sta_description: null,
            employee_representative_id: null,
            representative_name: null,
            rnl: null,
        },
        editedIndex: -1,
        editedItem: {
            description: null,
        },
        defaultItem: {
            descripcion: null,
        },
    }),
    components: {
        // Barra
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nuevo location" : "Editar location";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },

    created() {
        this.initialize();
    },

    methods: {
        async initialize() {
            this.getData();
            //combo ciudades---------------------------------------------
            this.itemsCities = await this.g_ComboGeneric("humanResource/cities");
            //combo unidades---------------------------------------------
            this.allBusiness = await this.g_bussines(true);
        },
        async getData() {
            this.locations = [];
            const result = await this.api_Get("humanResource/locations");
            const data = await result.json();
            this.locations = data;
        },
        editItem(item) {
            this.editedIndex = this.locations.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.newLocation = Object.assign({}, item);
            this.representante = item.representative_name;
            this.dialog = true;
        },

        deleteItem(item) {
            this.editedIndex = this.locations.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },

        async deleteItemConfirm() {
            const result = await this.api_Delete(
                "humanResource/locations/" + this.locations[this.editedIndex].id
            );
            if (result.status == 200) {
                this.$toast.success("Desactivado con exito!");
                this.getData();
            }
            this.locations.splice(this.editedIndex, 1);
            this.closeDelete();
        },
        async activeLocation(item) {
            const result = await this.api_Put(
                "humanResource/active_locations", { location_id: item.id });
            if (result.status == 200) {
                this.$toast.success("Location activado con exito!");
                this.getData();
                return
            }
            this.errorNotification('Error al activar el location!');
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        async save() {
            if (this.newLocation.bus_id == null) {
                this.$toast.error('Escoja la unidad a la que pertenece!');
                return
            }
            if (this.newLocation.desc_loc_short == null || this.newLocation.desc_loc_short.length < 2) {
                this.$toast.error('Indique un nombre corto valido!');
                return
            }
            if (this.newLocation.desc_loc_long == null || this.newLocation.desc_loc_long.length < 2) {
                this.$toast.error('Indique un nombre largo valido!');
                return
            }

            if (this.newLocation.city_id == null) {
                this.$toast.error('Indique la ciudad!');
                return
            }
            var datos = {
                id: this.newLocation.id,
                busines_unit_id: this.newLocation.bus_id,
                city_id_var: this.newLocation.city_id,
                description_short: this.newLocation.desc_loc_short,
                description_long: this.newLocation.desc_loc_long,
                address_description: this.newLocation.location_adress,
                employee_representative_id: this.newLocation.employee_representative_id,
                rnl: this.newLocation.rnl,
            };

            if (this.editedIndex > -1) {
                //Modificar
                const result = await this.api_Put("humanResource/locations", datos);
                if (result.status == 200) {
                    this.$toast.success("Actualizado con exito!");
                    this.getData();
                }
            } else {
                //Crear nuevo
                const result = await this.api_Post("humanResource/locations", datos);
                if (result.status == 200) {
                    const result = await this.api_Get("humanResource/locations");
                    const data = await result.json();
                    this.locations = data;
                    this.$toast.success("Guardado correctamente!");
                    this.getData();
                }
            }
            this.clearLocation();
            this.employee_code_add = null;
            this.close();
        },
        async searchEmployee() {
            if (this.employee_code_add == null) {
                this.$toast.error("Debe ingresar un codigo de empleado!");
                return;
            }
            this.dialogSearch = true;
            this.loadingSearch = true;
            const result = await this.api_Post("humanResource/employees/all", {
                filters:
                    " where EMPLOYEE_RECORDS_LAST_ACTION_VIEW_PERSISTENT.employee_code='" + this.clearInputFilter(this.employee_code_add, 6) + "'",
            });
            const data = await result.json();
            if (result.status == 200) {
                if ((await data.length) == 0) {
                    this.infoNotification(
                        "No se encontraro ningun empleado con este codigo!"
                    );
                    this.employee_new = null;
                    this.loadingSearch = false;
                    return;
                } else {
                    this.loadingSearch = false;
                    this.newLocation.employee_representative_id = data[0].employee_id
                    this.representante = data[0].employee_fullname + " (" + data[0].employee_code + ")";
                }
            }
            this.dialogSearch = false;
        },
        clearLocation() {
            this.newLocation = {
                id: null,
                bus_id: null,
                city_id: null,
                desc_bus_short: null,
                location_adress: null,
                desc_bus_long: null,
                desc_loc_short: null,
                desc_loc_long: null,
                status_id: null,
                sta_description: null,
                rnl: null,
                employee_representative_id: null,
            }
        },
        openDialogLocation() {
            this.clearLocation();
            this.dialog = true;
        }
    },
};
</script>